import gql from 'graphql-tag';
import CustomerOrderDescription from './CustomerOrderDescription';
import OrderFragment from './OrderFragment';

const CustomerOrderFragment = gql`
  fragment CustomerOrder on CustomerOrder {
    id
    orderId
    created
    merchantId
    amount
    description {
      ...CustomerOrderDescription
    }
    orderInformation {
      ...Order
    }
  }

  ${CustomerOrderDescription}
  ${OrderFragment}
`;

export default CustomerOrderFragment;


// WEBPACK FOOTER //
// ./src/graphql/fragments/order/CustomerOrderFragment.js